<template>
  <section class="app-main">
    <transition name="fade-transform" mode="out-in">
      <keep-alive :include="cachedViews">
        <router-view :key="key" />
      </keep-alive>
    </transition>
  </section>
</template>

<script>
export default {
  name: "AppMain",
  data() {
    return {};
  },
  components: {},
  computed: {
    cachedViews() {
      return this.$store.state.tagsView.cachedViews;
    },
    key() {
      const hasDetection = this.$route.path.includes("inspectionLite");
      return hasDetection ? this.$route.name : this.$route.path;
    },
  },
};
</script>
<style scoped>
.app-main {
  /*30 = navbar  */
  min-height: calc(100vh - 30px);
  width: 100%;
  position: relative;
  overflow-y: auto;
  overflow-x: hidden;
}
.fixed-header + .app-main {
  padding-top: 50px;
}
</style>

<style lang="scss">
.el-popup-parent--hidden {
  .fixed-header {
    padding-right: 15px;
  }
}
</style>
